// extracted by mini-css-extract-plugin
export default {"content":"GVMvS","title":"YPDJp","description":"dQ8wm","content-store":"rizEM","store-links":"i6qQS","icon-wrap":"nDVMQ","icon-ios":"o1ILj","icon":"rQaCn"};